import React from "react"
import styled, { keyframes, css } from "styled-components"
import { useInView } from "react-intersection-observer"

const moveRight = keyframes`
    0% {
        transform: translate3d(0,0,0);
    }
    50% {
      transform: translate3d(0,0,0);
    }
    to {
        transform: translate3d(30px,0px,0);
    }
`

const animation = css`
  ${moveRight} 1.5s ease-out 0s infinite alternate;
`

const SVG = styled.svg`
  overflow: visible;
  .a,
  .c {
    fill: none;
  }
  .a {
    stroke: #fff;
  }
  .a,
  .c {
    stroke-miterlimit: 10;
    stroke-width: 2px;
  }
  .b {
    fill: #ffe75c;
  }
  .c {
    stroke: #000;
  }
  .animated-group {
    animation: ${props => (props.inView ? animation : "none")};
  }
`

export default function Makhan() {
  const [ref, inView] = useInView({ triggerOnce: false })

  return (
    <SVG
      xmlns="http://www.w3.org/2000/svg"
      width="552.844"
      height="364.469"
      viewBox="0 0 552.844 364.469"
      ref={ref}
      inView={inView}
    >
      <path
        class="a"
        d="M55.295 300.48c16.47-14.811 32.506-29.364 45.951-46.768a9.636 9.636 0 00-1.419-.3c-19.979-1.075-39.967-2.016-59.936-3.248a107.136 107.136 0 01-35.488-8.161c-.508-.217-.981-.521-1.85-.986 4.439-1.42 8.522-2.668 12.566-4.032a566.048 566.048 0 0091.684-40.15c9.3-5.1 18.341-10.666 27.525-15.975a3.066 3.066 0 001.709-3.093 47.121 47.121 0 014.757-22.231 25.84 25.84 0 0112.077-12.285c15.924-7.492 31.891-14.9 47.84-22.336l2.075-.97c-.734-.28-1.2-.485-1.677-.634-11.777-3.663-23.636-7.086-35.318-11.035A445.376 445.376 0 01118 89.16c-16.219-7.665-31.905-16.277-45.756-27.828-7.5-6.257-14.454-13.073-18.893-21.988-3.736-7.5-4.927-15.213-.558-22.8 3.443-5.977 8.762-10.127 15-12.993 11.213-5.153 21.561-2.183 31.51 3.656 8.541 5.012 15.369 12.18 22.894 18.466 7.092 5.923 13.986 12.09 21.21 17.845 10.327 8.227 20.76 16.336 31.381 24.175a157.883 157.883 0 0016.119 10.086c9.467 5.355 19.085 10.439 28.634 15.649a5.041 5.041 0 004.262.557c2.741-.837 5.438.033 7.925 1.329 5.376 2.8 10.746 5.615 16.072 8.508a3.8 3.8 0 003.813.209c14.932-6.907 29.862-13.824 44.873-20.558a129.661 129.661 0 0117.682-6.915 76.572 76.572 0 0116.835-2.59q48.156-2.416 96.339-4.338a37.93 37.93 0 0123.564 7.278c4.852 3.418 6.739 8.542 7.2 14.179.567 6.97.829 13.965 1.245 21.315l53.645 4.652-30.232 32.991c22.72 2.94 45.115 2.564 68.021 1.673-1.169 1.553-2 2.857-3.023 3.984-9.657 10.638-19.011 21.578-29.11 31.779-13 13.129-26.712 25.55-39.9 38.493-7.26 7.123-14.048 14.724-21.146 22.017a5.973 5.973 0 01-3.486 1.663c-12.093.989-24.188 2.07-36.3 2.671-18.542.92-37.1 1.473-55.654 2.22a4.256 4.256 0 00-2.18.721q-21.082 15.01-42.122 30.084-19.742 14.088-39.556 28.073a6.643 6.643 0 01-3.834.858q-47.105-1.8-94.2-3.744c-14.651-.618-29.308-1.231-43.931-2.269-16.784-1.19-33.538-2.781-50.294-4.327-9.417-.869-18.809-2-28.211-3.017-.722-.077-1.419-.245-2.543-.444z"
      />
      <path
        class="c"
        d="M217.981 144.377c-.812-.479-1.1-.67-1.405-.825-3.667-1.85-7.342-3.683-11-5.546a5.879 5.879 0 01-3.447-6.382c.235-2.067.54-4.125.872-6.625"
      />
      <path
        class="b"
        d="M452.684 89.707a11.78 11.78 0 01.279 1.7q.547 21.439 1.05 42.876c.054 2.448-.258 4.909-.146 7.353.293 6.342-1.956 11.791-5.851 16.572-6.109 7.5-12.191 15.03-18.635 22.235-8.373 9.358-16.854 18.643-25.731 27.519-7.338 7.335-15.162 14.211-23.06 20.95-6.913 5.9-15.257 7.81-24.258 7.375-9.156-.442-18.323-.688-27.762-1.031a76.54 76.54 0 009.934-23.061c4.494 1.055 8.868 2.165 13.278 3.1 9.048 1.926 18.156 3.719 27.454 2.842a34.967 34.967 0 0010.829-2.7c10.37-4.638 10.113-16.879 6.214-23.131-3.52-5.645-8.536-9.754-13.924-13.44a2.9 2.9 0 01-1.344-2.646c-.39-6.7-.719-13.4-1.362-20.075-.417-4.32-3.292-7.07-6.978-9.031a31.879 31.879 0 00-15.5-3.386c-11.767.094-23.53.482-35.3.6a9.785 9.785 0 01-4.877-1.253q-26.616-14.942-53.118-30.081c-2.734-1.553-5.431-3.168-8.483-4.952 1.154-.571 1.955-1 2.781-1.372q19.006-8.623 38.017-17.231c4.322-1.955 8.689-3.809 12.98-5.825 7.834-3.679 16.281-4.5 24.7-4.953 28.057-1.507 56.131-2.713 84.194-4.106 6.513-.323 13.1-.772 19.374 1.017a36.553 36.553 0 017.919 3.606 15.138 15.138 0 016.8 7.888 7.3 7.3 0 01.526 2.644"
      />
      <path
        class="a"
        d="M202.995 124.996c-.332 2.5-.637 4.558-.872 6.625a5.879 5.879 0 003.447 6.382c3.66 1.862 7.335 3.7 11 5.546.305.155.593.345 1.405.825M106.639 65.737c-.859-.38-1.739-.72-2.575-1.148-9.154-4.686-17.857-10.058-25.528-16.977-5.257-4.74-9.923-9.956-11.994-16.908-1.714-5.756.669-10.285 6.032-13.044 9.692-4.986 18.064-2.287 25.724 4.237 7.8 6.646 15.167 13.826 23.179 20.2 13.269 10.553 26.9 20.647 40.383 30.934.569.435 1.133.879 1.7 1.318M210.376 99.721c-1.612 2.285-3.171 4.615-4.894 6.814-.28.358-1.35.361-1.944.174-21.825-6.86-43.436-14.3-64.092-24.24-5.911-2.845-11.7-5.931-17.545-8.921-.63-.323-1.21-.746-1.814-1.123M247.797 103.82l78.227 44.566 50.246 27.245s20.048 7.925 22.277 23.128-13.261 18.327-13.261 18.327-11.731 5.184-46.781-4.894l-5.113-1.969"
      />
      <path
        class="b animated-group"
        d="M315.518 239.298l.376.557c1.686-1.152 3.769-1.99 4.977-3.519a58.305 58.305 0 007.318-10.868c5.206-11.049 7.849-22.6 5.023-34.88a47.211 47.211 0 00-18.085-27.929c-11.792-8.884-25.493-12.5-39.854-14.309-11.051-1.39-22.068-.355-33.106.166a451.288 451.288 0 01-55.877-.857c-6.621-.508-13.237-1.48-19.858-1.494-13.082-.029-22.784 8.743-24.443 21.724a126.6 126.6 0 00-.894 13.613q-.414 21.671-.569 43.346c-.04 6.719 1.126 8.059 7.781 8.537 12.386.888 24.783 1.763 37.191 2.194 28.244.981 56.489.521 84.724-.584a3.5 3.5 0 002.191-1.191c2.344-2.708 4.311-5.793 6.89-8.238 6.832-6.476 13.564-13.03 18.446-21.148 6.084-10.12 6.612-18.413-1.9-27.911-3.505-3.913-7.651-7.253-11.138-10.511a48.705 48.705 0 0113.678 10.081c8.4 8.859 9.527 17.592 3.62 29.138-3.768 7.367-9.744 13.008-15.463 18.851a62.853 62.853 0 00-8.339 10.139c-2.733 4.326-1.511 7.882 2.731 10.728 5.155 3.458 10.79 3.849 16.63 2.531 11.083-2.5 17.922-9.918 22.579-19.789.373-.792.709-1.6 1.063-2.4a25.13 25.13 0 01-5.692 14.023z"
      />
      <g>
        <path
          class="b"
          d="M380.799 275.668q44.752 24.338 42.153 71.194c-1.213 5.085-60.178-4.059-70.215-3.312-10.552.787-17.138-7.953-15.56-16.607 4.856-26.64 17.834-45.274 43.622-51.275z"
        />
        <path
          d="M380.799 275.67c-16.932 3.94-28.341 13.325-35.555 26.847a94.373 94.373 0 008.361 14.296c5.023 7.163 15.853 8.706 22.753.597 3.152-3.712 15.987-13.929 28.09-24.003a93.67 93.67 0 00-23.65-17.74z"
          fill="#feea78"
        />
      </g>
      <path
        d="M389.547 276.311a7.272 7.272 0 00-5.39-.727c-22.174 5.742-35.48 22.81-39.543 50.734-1.834 12.595 7.758 24.902 21.165 23.592 6.037-.534 43.028 5.005 54.08 3.451 6.386-.897 9.135-4.56 9.247-8.853.781-29.114-11.929-52.663-39.559-68.197z"
        stroke-width="2"
        stroke="#fff"
        fill="none"
      />
    </SVG>
  )
}
